// Manda errores del navegador al backend, que los guarda en la tabla de errores
// visible desde el admin de Django. Sirve sobre todo para las tablets en jornada,
// donde hoy un fallo no deja ningún rastro.

const ENDPOINT = 'https://admin-django-inspira.azurewebsites.net/api/logs/client-error/';

// Si falla el propio reporte no volvemos a reportar: se haría un bucle.
let reporting = false;

// El backend limita a 60 por hora por IP; no tiene caso gastarlos en el mismo
// error repetido mil veces.
const yaReportados = new Set();

export const reportError = (message, { stack = '', context = null, level = 'ERROR' } = {}) => {
    if (reporting || !message) return;

    const huella = `${message}|${stack.slice(0, 200)}`;
    if (yaReportados.has(huella)) return;
    yaReportados.add(huella);

    reporting = true;
    fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            message: String(message).slice(0, 2000),
            stack: String(stack).slice(0, 20000),
            path: window.location.pathname + window.location.search,
            level,
            context,
        }),
    })
        .catch(() => { /* si no hay red, no hay nada que hacer */ })
        .finally(() => { reporting = false; });
};

// Errores que nadie atrapó y promesas rechazadas sin .catch
export const installGlobalErrorReporting = () => {
    window.addEventListener('error', (event) => {
        reportError(event.message, {
            stack: event.error && event.error.stack ? event.error.stack : '',
            context: { tipo: 'window.error', archivo: event.filename, linea: event.lineno },
        });
    });

    window.addEventListener('unhandledrejection', (event) => {
        const motivo = event.reason;
        reportError(
            motivo && motivo.message ? motivo.message : String(motivo),
            {
                stack: motivo && motivo.stack ? motivo.stack : '',
                context: { tipo: 'unhandledrejection' },
            }
        );
    });
};
